import { format } from "date-fns";
import { WORK_ORDER_STATUS } from "../../stores/work_orders";

const ISO_DATE_FORMAT = "yyyy-MM-dd";

export const WORK_ORDER_VIEW = Object.freeze({
  LIST: "list",
  MAP: "map",
});

export const DUE_STATE = Object.freeze({
  OVERDUE: "overdue",
  DUE: "due",
  NONE: "none",
});

const DUE_STATES_BY_URGENCY = [DUE_STATE.OVERDUE, DUE_STATE.DUE, DUE_STATE.NONE];

// Only open orders need attention; a lone date acts as both start and
// end of the scheduled window.
export const getDueState = (workOrder, today = format(new Date(), ISO_DATE_FORMAT)) => {
  if (workOrder.status !== WORK_ORDER_STATUS.OPEN) return DUE_STATE.NONE;
  const scheduleStart = workOrder.scheduled_from || workOrder.scheduled_until;
  const scheduleEnd = workOrder.scheduled_until || workOrder.scheduled_from;
  if (scheduleEnd && today > scheduleEnd) return DUE_STATE.OVERDUE;
  if (scheduleStart && scheduleStart <= today) return DUE_STATE.DUE;
  return DUE_STATE.NONE;
};

const mostUrgent = (left, right) =>
  DUE_STATES_BY_URGENCY.indexOf(left) <= DUE_STATES_BY_URGENCY.indexOf(right) ? left : right;

// Work orders at the same property share one pin, colored by the most
// urgent of them. Unlocated work orders get no pin.
export const groupMapItemsByLocation = (items, today = format(new Date(), ISO_DATE_FORMAT)) => {
  const locations = new Map();
  items.forEach((item) => {
    if (!item.property_location) return;
    const { address, lat, lon } = item.property_location;
    const key = `${lat},${lon}`;
    const dueState = getDueState(item, today);
    const location = locations.get(key);
    if (location) {
      location.workOrders.push(item);
      location.dueState = mostUrgent(location.dueState, dueState);
      return;
    }
    locations.set(key, { key, lat, lon, address, dueState, workOrders: [item] });
  });
  return [...locations.values()];
};
